// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteShopOrderRequestModel from '../../model/delete-shop-order-request-model';
import DeleteShopOrderRequestDTO from '../dto/delete-shop-order-request-dto';
import dtoSchema from '../schemas/delete-shop-order-request-schema';

export default abstract class DeleteShopOrderRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteShopOrderRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteShopOrderRequestDTO>): DeleteShopOrderRequestModel;
  static toModel(dto: DeepPartial<DeleteShopOrderRequestDTO> | undefined | null): DeleteShopOrderRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteShopOrderRequestDTO> | undefined | null): DeleteShopOrderRequestModel | undefined {
    return dto ? new DeleteShopOrderRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteShopOrderRequestModel> | DeleteShopOrderRequestModel): DeleteShopOrderRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteShopOrderRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteShopOrderRequestModel, can not map to DeleteShopOrderRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
